import { gql } from '@apollo/client'

export default gql`
  mutation VendorAccountAddTlv($vendorAccountId: ID!, $tags: [TlvInput!]!) {
    VendorAccountAddTlv(vendorAccountId: $vendorAccountId, tags: $tags) {
      message
      status
      data {
        id
        name
        value
        vendorAccountId
      }
    }
  }
`
